import { useEffect, useState } from "react";
import "../../assets/volunteers.css";
import eventLogo from "../../assets/eventLogo.png";
import { getStencil } from "../../lib/services/stencilService";
import { getCategory } from "../../lib/services/categoryService";
import { volunteerStatus } from "../../lib/services/authService";
import { useNavigate } from "react-router-dom";
import { getAllIncomplete } from "../../lib/utils/stencilWeekUtils";

export default function StencilInfo({
  setIsVolunteerAuthenticated,
  setStencilData,
  setVolunteerName,
  volunteerName,
}) {
  const navigate = useNavigate();

  // stencil info
  const [stencilId, setStencilId] = useState("");

  useEffect(() => {
    const checkVolunteerStatus = async () => {
      const response = await volunteerStatus();
      if (response.ok) {
        const data = await response.json();
        setIsVolunteerAuthenticated(data.isAuthenticated);
      }
    };

    checkVolunteerStatus();
  }, []);

  async function submitId() {
    // check input:
    const id = stencilId.trim();
    const name = volunteerName.trim();

    // validate inputs
    if (!id) {
      alert("Please enter a Stencil ID.");
      return;
    }
    if (!name) {
      alert("Please enter your name.");
      return;
    }

    // get stencil data:
    const data = await getStencil(id);

    if (!data.stencil) {
      alert(`Error loading stencils ${id}`);
      return;
    }

    const cat =
      data.stencil.category_id === null
        ? null
        : await getCategory(data.stencil.category_id);

    // find all stencil_weeks obejcts(max 3, this mean week 1,2,3)
    // that are not yet fully traced + carved
    // return an array of stencil_week objects
    const allIncomplete = await getAllIncomplete(data.stencil);

    // Stencil is fully traced + carved in all weeks, we do nothing and notify the volunteer
    if (allIncomplete.length === 0) {
      alert("This stencil has no available work.");
      return;
    }

    // save stencil information for later steps
    setStencilData({
      stencil: data.stencil,
      category: data.stencil.category_id === null ? null : cat.categories,
    });

    // Pass the full list of stencil weeks to the confirm page
    //TODO: we don't via navigate.
    navigate("/volunteer/confirm", {
      state: { stencilWeeks: allIncomplete },
    });
  }

  return (
    <div className="vol-wrap">
      <div className="vol-stack">
        {/* Brand logo above the card */}
        <img
          src={eventLogo}
          alt="Spirits in the Gardens"
          className="vol-logo"
          loading="eager"
        />

        {/* WHITE CARD */}
        <div className="vol-card">
          <h2 className="vol-title">Please enter Stencil ID and your name</h2>
          <span>Note: Stencil ID is case sensitive</span>
          <input
            className="vol-input"
            placeholder="e.g.0-00-A"
            value={stencilId}
            onChange={(e) => setStencilId(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submitId()}
            autoFocus
          />

          <input
            className="vol-input"
            placeholder="Your first name"
            value={volunteerName}
            onChange={(e) => setVolunteerName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submitId()}
          />

          <p className="vol-foot">Both fields are required to continue.</p>
        </div>

        {/* BUTTONS OUTSIDE THE CARD */}
        <div className={`vol-actions-outside grid-2`}>
          <button className="vol-btn primary" onClick={submitId}>
            Submit
          </button>
          <button
            className="vol-btn ghost"
            onClick={() => {
              setStencilId("");
              setVolunteerName("");
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
